import React, { useCallback } from 'react';
import { Tappable } from '@vectord/components';
import { useDispatch } from 'react-redux';

import {
  setUploadVideoModalState,
  UploadedVideos,
  UploadedVideosSearch,
  UploadVideoModal,
} from 'features/assetManagement';
import SectionHeading from 'components/SectionHeading';
import styles from './UploadVideoPage.module.scss';

function UploadVideoPage() {
  const dispatch = useDispatch();

  const openUploadModal = useCallback(() => {
    dispatch(setUploadVideoModalState(true));
  }, [dispatch]);

  return (
    <div className={styles.videoUploadPage}>
      <SectionHeading title="UPLOAD VIDEO" />
      <div className={styles.videoUploadHeader}>
        <UploadedVideosSearch className={styles.searchInput} />
        <Tappable
          className="btn btn-primary p-xs"
          onClick={openUploadModal}
        >
          Upload Video
        </Tappable>
      </div>
      <UploadedVideos />
      <UploadVideoModal />
    </div>
  );
}
export default UploadVideoPage;
